import agentContractAlertDictionary from '@widgets/agent-contract-alert/i18n/ru/agent-contract-alert.dic.json';

export const agentContractAlert = {
  AGENT_CONTRACT_ALERT: agentContractAlertDictionary,
};

export const agentContractAlertNamespaces = ['AGENT_CONTRACT_ALERT'];
